export default {
  BusinessStockDeliveryCom: {
    title: '查看出库结果单号',
    code: '出库结果单号',
  }
};
